/* import __COLOCATED_TEMPLATE__ from './permission-cell-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();